<template>
  <v-container>
    <v-card
    >
      <v-toolbar
        color="red"
        dark
      >
        <v-app-bar-nav-icon></v-app-bar-nav-icon>

        <v-toolbar-title>{{ $t('common:image') }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container fluid>
        <v-row dense>
          <v-col
            cols="12"
          >
            <v-card>
              <v-card-title v-text="elevator.name"></v-card-title>
              <div class="text-xs-center" :style="`transform: rotate(${rotation}deg);`">
                <v-img
                  :src="image.src"
                  class="white--text align-end cursor-pointer"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  @click="showDialog = true"
                  max-width="808"
                  max-height="808"
                ></v-img>
              </div>

              <v-card-title class="text-h6">
                {{ image.date }}
              </v-card-title>

              <v-card-text>
                <div> {{elevator.name}} </div>
                <div> {{elevator.id}} </div>
                <div> {{elevator.street}} </div>
                <div> {{elevator.zip}} {{elevator.city}}</div>
                <div> {{elevator.country.name}}</div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  @click="previousImage"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="nextImage"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>

                <v-btn
                  @click="$emit('imageRequest')"
                  icon>
                  <v-icon>sync</v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="rotateImage">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="showDialog"
      max-width="70%"
      content-class="image-viewer">

      <v-card>
        <v-toolbar fixed flat>
          <v-row align="center">
            <!-- Close Button -->
            <v-col cols="12" sm="12" md="12" class="text-right">
              <v-icon
                @click="showDialog = false"
                class="greyBold--text"
              > close
              </v-icon>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-img
            id="big-image"
            :src="image.src"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import Elevator from '@/modules/display/data/elevator.js';

export default {
  name: "MediaContainer",
  props: {
    gallery: Array,
    elevator: {
      type: Object,
      default: () => (new Elevator())
    }
  },
  data() {
    return {
      emergency: {},
      image: {
        src: '',
        date: ''
      },
      rotation: 0,
      currentGalleryPosition: 0,
      showDialog: false
    }
  },
  watch: {
    gallery() {
      if (this.gallery.length === 0) return;
      this.currentGalleryPosition = 0;

      this.setImage(this.currentGalleryPosition);
    }

  },
  methods:{
    rotateImage() {
      if (this.rotation === 270) {
        this.rotation = 0;
      } else {
        this.rotation += 90;
      }
    },

    setImage(position) {
      if (!this.gallery[position]) return;

      this.image.src = 'data:image/jpeg;base64,' + this.gallery[position].imageSrc;
      this.image.date = this.gallery[position].imageTime;
    },

    previousImage() {
      this.currentGalleryPosition--;
      if (this.currentGalleryPosition < 0) {
        this.currentGalleryPosition = this.gallery.length - 1;
      }

      this.setImage(this.currentGalleryPosition);
    },

    nextImage() {
      this.currentGalleryPosition++;
      if (this.currentGalleryPosition === this.gallery.length) {
        this.currentGalleryPosition = 0;
      }

      this.setImage(this.currentGalleryPosition);
    }
  }
}
</script>

<style src="@/modules/core/components/DocumentViewer/ImageViewer.scss" lang="scss"/>